module.exports = __webpack_public_path__ + "img/bis_no.b2199ed8.png";